function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FalsyFC, FalsyText, TouchableWithoutFeedback } from "../../devsupport";
import { Interaction } from "../../theme";
import { NativeDateService } from "../calendar/service/nativeDate.service";
import { Popover } from "../popover/popover.component";
import { PopoverPlacements } from "../popover/type";
export class BaseDatepickerComponent extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      visible: false
    });

    _defineProperty(this, "popoverRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "show", () => {
      var _this$popoverRef$curr;

      (_this$popoverRef$curr = this.popoverRef.current) === null || _this$popoverRef$curr === void 0 ? void 0 : _this$popoverRef$curr.show();
    });

    _defineProperty(this, "hide", () => {
      var _this$popoverRef$curr2;

      (_this$popoverRef$curr2 = this.popoverRef.current) === null || _this$popoverRef$curr2 === void 0 ? void 0 : _this$popoverRef$curr2.hide();
    });

    _defineProperty(this, "focus", () => {
      this.setState({
        visible: true
      }, this.onPickerVisible);
    });

    _defineProperty(this, "blur", () => {
      this.setState({
        visible: false
      }, this.onPickerInvisible);
    });

    _defineProperty(this, "isFocused", () => {
      return this.state.visible;
    });

    _defineProperty(this, "getComponentStyle", style => {
      const {
        textMarginHorizontal,
        textFontFamily,
        textFontSize,
        textFontWeight,
        textColor,
        placeholderColor,
        iconWidth,
        iconHeight,
        iconMarginHorizontal,
        iconTintColor,
        labelColor,
        labelFontSize,
        labelMarginBottom,
        labelFontWeight,
        labelFontFamily,
        captionMarginTop,
        captionColor,
        captionFontSize,
        captionFontWeight,
        captionFontFamily,
        captionIconWidth,
        captionIconHeight,
        captionIconMarginRight,
        captionIconTintColor,
        popoverWidth
      } = style,
            controlParameters = _objectWithoutProperties(style, ["textMarginHorizontal", "textFontFamily", "textFontSize", "textFontWeight", "textColor", "placeholderColor", "iconWidth", "iconHeight", "iconMarginHorizontal", "iconTintColor", "labelColor", "labelFontSize", "labelMarginBottom", "labelFontWeight", "labelFontFamily", "captionMarginTop", "captionColor", "captionFontSize", "captionFontWeight", "captionFontFamily", "captionIconWidth", "captionIconHeight", "captionIconMarginRight", "captionIconTintColor", "popoverWidth"]);

      return {
        control: controlParameters,
        captionContainer: {
          marginTop: captionMarginTop
        },
        text: {
          marginHorizontal: textMarginHorizontal,
          fontFamily: textFontFamily,
          fontSize: textFontSize,
          fontWeight: textFontWeight,
          color: textColor
        },
        placeholder: {
          marginHorizontal: textMarginHorizontal,
          color: placeholderColor
        },
        icon: {
          width: iconWidth,
          height: iconHeight,
          marginHorizontal: iconMarginHorizontal,
          tintColor: iconTintColor
        },
        label: {
          color: labelColor,
          fontSize: labelFontSize,
          fontFamily: labelFontFamily,
          marginBottom: labelMarginBottom,
          fontWeight: labelFontWeight
        },
        captionIcon: {
          width: captionIconWidth,
          height: captionIconHeight,
          tintColor: captionIconTintColor,
          marginRight: captionIconMarginRight
        },
        captionLabel: {
          fontSize: captionFontSize,
          fontWeight: captionFontWeight,
          fontFamily: captionFontFamily,
          color: captionColor
        },
        popover: {
          width: popoverWidth,
          marginBottom: captionMarginTop
        }
      };
    });

    _defineProperty(this, "onPress", event => {
      this.setPickerVisible();
      this.props.onPress && this.props.onPress(event);
    });

    _defineProperty(this, "onPressIn", event => {
      this.props.eva.dispatch([Interaction.ACTIVE]);
      this.props.onPressIn && this.props.onPressIn(event);
    });

    _defineProperty(this, "onPressOut", event => {
      this.props.eva.dispatch([]);
      this.props.onPressOut && this.props.onPressOut(event);
    });

    _defineProperty(this, "onPickerVisible", () => {
      this.props.eva.dispatch([Interaction.ACTIVE]);
      this.props.onFocus && this.props.onFocus();
    });

    _defineProperty(this, "onPickerInvisible", () => {
      this.props.eva.dispatch([]);
      this.props.onBlur && this.props.onBlur();
    });

    _defineProperty(this, "setPickerVisible", () => {
      this.setState({
        visible: true
      }, this.onPickerVisible);
    });

    _defineProperty(this, "setPickerInvisible", () => {
      this.setState({
        visible: false
      }, this.onPickerInvisible);
    });

    _defineProperty(this, "renderInputElement", (props, evaStyle) => {
      return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, _extends({}, props, {
        style: [evaStyle.control, styles.control, this.props.controlStyle],
        onPress: this.onPress,
        onPressIn: this.onPressIn,
        onPressOut: this.onPressOut
      }), /*#__PURE__*/React.createElement(FalsyFC, {
        style: evaStyle.icon,
        component: this.props.accessoryLeft
      }), /*#__PURE__*/React.createElement(FalsyText, {
        style: evaStyle.text,
        numberOfLines: 1,
        ellipsizeMode: "tail",
        component: this.getComponentTitle()
      }), /*#__PURE__*/React.createElement(FalsyFC, {
        style: evaStyle.icon,
        component: this.props.accessoryRight
      }));
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      backdropStyle,
      controlStyle,
      placement,
      label,
      accessoryLeft,
      accessoryRight,
      caption,
      captionIcon
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "backdropStyle", "controlStyle", "placement", "label", "accessoryLeft", "accessoryRight", "caption", "captionIcon"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(View, {
      style: style
    }, /*#__PURE__*/React.createElement(FalsyText, {
      style: [evaStyle.label, styles.label],
      component: label
    }), /*#__PURE__*/React.createElement(Popover, {
      ref: this.popoverRef,
      style: [evaStyle.popover, styles.popover],
      backdropStyle: backdropStyle,
      placement: placement,
      visible: this.state.visible,
      anchor: () => this.renderInputElement(touchableProps, evaStyle),
      onBackdropPress: this.setPickerInvisible
    }, this.renderCalendar()), /*#__PURE__*/React.createElement(View, {
      style: [evaStyle.captionContainer, styles.captionContainer]
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.captionIcon,
      component: captionIcon
    }), /*#__PURE__*/React.createElement(FalsyText, {
      style: [evaStyle.captionLabel, styles.captionLabel],
      component: caption
    })));
  }

}

_defineProperty(BaseDatepickerComponent, "defaultProps", {
  dateService: new NativeDateService(),
  placeholder: 'dd/mm/yyyy',
  placement: PopoverPlacements.BOTTOM_START
});

const styles = StyleSheet.create({
  popover: {
    borderWidth: 0
  },
  control: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  label: {
    textAlign: 'left'
  },
  captionContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  captionLabel: {
    textAlign: 'left'
  }
});